import { useCallback, useEffect, useState } from "react";
import { ScheduleDocument } from "../interfaces/ISchedules";
import { findPublishedSchedules, subscribePublishedSchedules } from "../services/schedulesService";

export const usePublishedSchedules = (competitionId: string | undefined) => {
  const [schedules, setSchedules] = useState<ScheduleDocument[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refreshSchedules = useCallback(async () => {
    if (!competitionId) {
      setSchedules([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const data = await findPublishedSchedules(competitionId);
      setSchedules(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Wystąpił błąd podczas odczytu harmonogramów.");
    } finally {
      setLoading(false);
    }
  }, [competitionId]);

  useEffect(() => {
    if (!competitionId) {
      setSchedules([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = subscribePublishedSchedules(
      competitionId,
      (data) => {
        setSchedules(data);
        setLoading(false);
      },
      (err) => {
        setError(err.message);
        setLoading(false);
      },
    );

    return () => unsubscribe();
  }, [competitionId]);

  return {
    schedules,
    loading,
    error,
    refreshSchedules,
  };
};
